// src/components/platform/LicensingPanel.jsx
import { useState } from "react";
import LicensingImageryTable from "../../platform/components/LicensingImageryTable";
import LicensingAnalyticsTable from "../../platform/components/LicensingAnalyticsTable";

const TABS = ["imagery", "analytics"];

export default function LicensingPanel() {
  const [activeTab, setActiveTab] = useState("imagery");

  return (
    <div className="p-6 h-full flex flex-col">
      <div className="mb-4">
        <h1 className="text-lg font-semibold">Licensing</h1>
        <p className="text-xs text-muted">
          Cross-org view of all imagery and analytics entitlements.
        </p>
      </div>

      <div className="flex gap-4 border-b border-bg-border mb-4">
        {TABS.map(t => (
          <button
            key={t}
            onClick={() => setActiveTab(t)}
            className={`px-3 py-2 text-xs uppercase tracking-wide border-b-2 ${
              activeTab === t
                ? "border-accent-action text-accent-action"
                : "border-transparent text-gray-400 hover:text-gray-200"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="flex-1 overflow-hidden">
        {activeTab === "imagery" && <LicensingImageryTable />}
        {activeTab === "analytics" && <LicensingAnalyticsTable />}
      </div>
    </div>
  );
}